// @ts-expect-error not typed yet

import EMAIL_TEMPLATE_MODE from 'EmailData/enums/EmailTemplateModes';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Small } from 'foundations-components/transitional/components/Small';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function EmailTemplateRadioInputs({
  email,
  isConvertible,
  onSelectTemplateMode,
  selectedTemplateMode
}) {
  const emailTemplateMode = useMemo(() => email.emailTemplateMode, [email]);
  const tooltip = useMemo(() => {
    if (emailTemplateMode === EMAIL_TEMPLATE_MODE.DRAG_AND_DROP) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.emailClone.cloneSidePanel.radioInputs.dndTooltip"
      });
    } else if (emailTemplateMode === EMAIL_TEMPLATE_MODE.DESIGN_MANAGER && !isConvertible) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.emailClone.cloneSidePanel.radioInputs.customTooltip"
      });
    }
    return null;
  }, [emailTemplateMode, isConvertible]);
  const body = useMemo(() => {
    if (emailTemplateMode === EMAIL_TEMPLATE_MODE.DRAG_AND_DROP) {
      return /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        children: /*#__PURE__*/_jsx(HelpIcon, {
          title: tooltip,
          tooltipPlacement: "right",
          color: "icon-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "dnd-only",
            message: "email-management.emailClone.cloneSidePanel.radioInputs.dnd"
          })
        })
      });
    } else if (emailTemplateMode === EMAIL_TEMPLATE_MODE.DESIGN_MANAGER && !isConvertible) {
      return /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        children: /*#__PURE__*/_jsx(HelpIcon, {
          title: tooltip,
          tooltipPlacement: "right",
          color: "icon-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "custom-only",
            message: "email-management.emailClone.cloneSidePanel.radioInputs.custom"
          })
        })
      });
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(ToggleGroup, {
          name: "email-template",
          "data-test-id": "email-template-toggle-group",
          children: [/*#__PURE__*/_jsx(RadioInput, {
            marginBlockStart: "200",
            onChange: () => onSelectTemplateMode(EMAIL_TEMPLATE_MODE.DESIGN_MANAGER),
            description: /*#__PURE__*/_jsx(Small, {
              use: "help",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "email-management.emailClone.cloneSidePanel.radioInputs.customDescription"
              })
            }),
            checked: selectedTemplateMode === EMAIL_TEMPLATE_MODE.DESIGN_MANAGER,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.emailClone.cloneSidePanel.radioInputs.custom"
            })
          }), /*#__PURE__*/_jsx(RadioInput, {
            marginBlockStart: "200",
            onChange: () => onSelectTemplateMode(EMAIL_TEMPLATE_MODE.DRAG_AND_DROP),
            checked: selectedTemplateMode === EMAIL_TEMPLATE_MODE.DRAG_AND_DROP,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.emailClone.cloneSidePanel.radioInputs.dnd"
            })
          })]
        }), selectedTemplateMode === EMAIL_TEMPLATE_MODE.DRAG_AND_DROP && /*#__PURE__*/_jsx(Alert, {
          type: "warning",
          marginBlockStart: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailClone.cloneSidePanel.radioInputs.convertDNDWarning",
            options: {
              editorName: I18n.text('email-management.emailClone.cloneSidePanel.radioInputs.dnd')
            }
          })
        })]
      });
    }
  }, [emailTemplateMode, isConvertible, onSelectTemplateMode, selectedTemplateMode, tooltip]);
  return /*#__PURE__*/_jsx(FormControl, {
    marginBlockStart: "300",
    "data-test-id": "email-template-radio-inputs",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.emailClone.cloneSidePanel.radioInputs.label"
    }),
    children: body
  });
}